<script lang="ts">
	//Svelte hooks
	import { onMount } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	import { repo } from 'src/services/http';
	//Stores
	import { devices } from 'src/stores/lists/devices';
import { device_object } from 'src/stores/wizards';
	import { devices_config } from '@devices/index';
	//Design system components
	import {
		CardGrid,
		AdvancedCard,
		Text,
		Button,
		Loader,
		toast,
		Icon,
		disableWrapperFocus,
	} from '@Shelly/shelly-design-system';
	//Components
	import EmptyList from 'src/components/Lists/EmptyList.svelte';

	import { addDeviceModal } from 'src/stores/device-runtime/firmware-ui';
	import { capFirstChar } from 'src/helpers/utilities';

	let allLoqedDevices = {};
	let loading = false;

	$: availableDevices =
		typeof allLoqedDevices !== 'undefined' && allLoqedDevices !== null
			? Object.values(allLoqedDevices).filter((d: any) => {
					d.type = 'LOQED';
					d.displayID = d?.id?.startsWith('XLQ') ? d.id : `XLQ${d.id}`;
					d.id = d.displayID;
					return d && $devices[d.id] === undefined;
				})
			: [];

	$: includedDevices =
		typeof allLoqedDevices !== 'undefined' && allLoqedDevices !== null
			? Object.values(allLoqedDevices).filter((d: any) => {
					if ($devices[d.id] !== undefined) {
						d.type = 'LOQED';
						d.displayID = d?.id?.startsWith('XLQ') ? d.id : `XLQ${d.id}`;
						d.id = d.displayID;
						d.name = $devices[d.id].name;

						return d;
					}
				})
			: [];

	$: availableDevicesCount = Object.values(availableDevices).length;
	$: includedDevicesCount = Object.values(includedDevices).length;

	onMount(async () => {
		try {
			loading = true;
			let res = await repo.post(`device/list_locks`);

			if (res?.data?.isok) {
				allLoqedDevices = res?.data?.data;
			}
		} catch (error) {
			console.error('cannot get Loqed devices');
			toast.open({
				type: 'danger',
				title: $format('error_global'),
			});
		} finally {
			loading = false;
		}
	});

	const handleDeviceSelect = (device) => {
		let selectedDevice = {
			id: device.id,
			type: device.type,
			category: devices_config[device.type]?.family,
			position: -1,
			gen: 'GXL',
			channel: 0,
			channels_count: 1,
			mode: '',
			name: device?.name,
			room_id: undefined,
			image: `images/device_images/${device.type}.png`,
			cloud_options: { exclude_event_log: false },
		};

		device_object.reset();
		device_object.set({
			...selectedDevice,
			enableCloudAfterAccountAssociation: false,
		});
		addDeviceModal.set(true);
	};
</script>

{#if loading}
	<div class="d-flex justify-content-center align-items-center">
		<Loader size="m" />
	</div>
{:else if !availableDevicesCount && !includedDevicesCount}
	<div class="text-center d-flex flex-direction-column align-items-center">
		<Icon class="mb-m" size="l" icon="fak fa-light-microchip-slash" />
		<EmptyList
			title={$format('empty_loqed_list_title', {
				default: 'No Loqed devices available',
			})}
			description={$format('empty_loqed_list_description', {
				default: 'There are no devices associated with this Loqed account',
			})}
			withoutMargin={true}
		/>
	</div>
{:else}
	<div class="d-flex justify-content-center align-items-center mb-l">
		<Text element="h1" class="text-center">
			{$format('text_choose_device_inclusion', {
				default: 'Choose the device you want to include',
			})}
		</Text>
	</div>

	{#if includedDevicesCount}
		<Text element="h2" class="mb-s">
			{$format('text_already_added', {
				default: `Already added (${includedDevicesCount})`,
				values: { count: includedDevicesCount },
			})}
		</Text>
		<CardGrid sm={200} md={300} lg={300} noPaddingBottom>
			{#each includedDevices as d}
				<div use:disableWrapperFocus>
					<AdvancedCard
						isCondensed
						class="width-full"
						type="horizontal"
						avatar={{
							image: `images/device_images/${d.type}.png`,
						}}
						title={`${d.name}`}
						description={{
							value: `${d.id}`,
							type: 'muted',
							bold: false,
							textSmall: true,
						}}
					/>
				</div>
			{/each}
		</CardGrid>

		{#if availableDevicesCount}
			<hr class="mb-m mt-m" />
		{/if}
	{/if}

	{#if availableDevicesCount}
		<Text element="h2" class="mb-s">
			{`Available devices (${availableDevicesCount})`}
		</Text>
		<CardGrid sm={200} md={300} lg={300} noPaddingBottom>
			{#each availableDevices as discoveredDevice}
				<div use:disableWrapperFocus>
					<AdvancedCard
						isCondensed
						class="width-full"
						type="horizontal"
						avatar={{
							image: `images/device_images/${discoveredDevice.type}.png`,
						}}
						title={`${discoveredDevice.name}`}
						description={{
							value: `${discoveredDevice.id}`,
							type: 'muted',
							bold: false,
							textSmall: true,
						}}
					>
						<div slot="right" class="d-flex align-items-center">
							<Button
								size="m"
								on:click={() => {
									handleDeviceSelect(discoveredDevice);
								}}>{capFirstChar($format('button_add', { default: 'Add' }))}</Button
							>
						</div>
					</AdvancedCard>
				</div>
			{/each}
		</CardGrid>
	{/if}
{/if}
